import uuid from 'uuid/v4';

const toastReducer = (state = false, action) => {
  switch (action.type) {
    case 'SHOWTOAST':
      return {
        id: uuid(),
        open: true,
        message: action.message,
        icon: action.icon,
      };
    case 'HIDETOAST':
      return false;
    default:
      return state;
  }
};

export default toastReducer;
